import type { Category } from '@/types';

export const categories: Category[] = [
  {
    id: 'football',
    name: '足球赛事',
    shortName: '足球',
    icon: 'ri-football-line',
    description: '全球各大联赛与杯赛的实时赛程，涵盖五大联赛、欧冠等焦点对决与黑5数据走势。',
    count: 128,
  },
  {
    id: 'basketball',
    name: '篮球赛事',
    shortName: '篮球',
    icon: 'ri-basketball-line',
    description: 'NBA、CBA 及国际邀请赛全覆盖，追踪球队攻防效率与核心球员数据变化。',
    count: 96,
  },
  {
    id: 'esports',
    name: '电竞赛事',
    shortName: '电竞',
    icon: 'ri-gamepad-line',
    description: '英雄联盟、王者荣耀、CS 等热门项目的赛事动态与战队黑5指数对比。',
    count: 74,
  },
  {
    id: 'tennis',
    name: '网球赛事',
    shortName: '网球',
    icon: 'ri-trophy-line',
    description: '大满贯与 ATP / WTA 巡回赛的赛程安排、选手状态与关键分数据解析。',
    count: 52,
  },
  {
    id: 'baseball',
    name: '棒球赛事',
    shortName: '棒球',
    icon: 'ri-run-line',
    description: '职业联赛与洲际赛事跟踪，重点关注投打数据变化与关键局走势。',
    count: 38,
  },
  {
    id: 'hockey',
    name: '冰球赛事',
    shortName: '冰球',
    icon: 'ri-snowy-line',
    description: '职业冰球联赛及国际赛事，分析攻防节奏、射正率与门将扑救表现。',
    count: 31,
  },
];

export const findCategory = (id: string): Category | undefined =>
  categories.find((item) => item.id === id);